import airBalloonSvg from "./illustrations/air-balloon.svg?raw"
import aletterSvg from "./illustrations/aletter.svg?raw"
import clockSvg from "./illustrations/clock.svg?raw"
import cupSvg from "./illustrations/cup.svg?raw"
import handVictorySvg from "./illustrations/hand-victory.svg?raw"
import languagesSvg from "./illustrations/languages.svg?raw"
import notesSvg from "./illustrations/notes.svg?raw"
import penSvg from "./illustrations/pen.svg?raw"
import specialGrowingLeavesSvg from "./illustrations/special-growing-leaves.svg?raw"
import streamSvg from "./illustrations/stream.svg?raw"
import trophySvg from "./illustrations/trophy.svg?raw"

export const illustrationSvgs = {
  "air-balloon": airBalloonSvg,
  aletter: aletterSvg,
  clock: clockSvg,
  cup: cupSvg,
  "hand-victory": handVictorySvg,
  languages: languagesSvg,
  notes: notesSvg,
  pen: penSvg,
  "special-growing-leaves": specialGrowingLeavesSvg,
  stream: streamSvg,
  trophy: trophySvg,
} as const

export type IllustrationName = keyof typeof illustrationSvgs
